import { ErrorMessage, Field, useFormikContext } from 'formik'
import { useState } from 'react'

import VisibilityOff from 'jsx:/assets/ic_visibility_off.svg'
import Visibility from 'jsx:/assets/ic_visibility.svg'
import TfPassword from 'jsx:/assets/ic_tf_password.svg'
import classNames from 'classnames'
import { getValueByName } from './InputUsernameLogin'
import { FormLabel } from '../genericComponents/layout/FormLabel'

export const InputPasswordLogin: React.FC<{
  type?: string
  label?: string
  placeholder?: string
  name: string
  className?: string
  classNameForInput?: string
  disabled?: boolean
  autocompleteOff?: boolean
}> = (props) => {
  const { values } = useFormikContext()
  const value = getValueByName(props.name, values)

  const [exposePassword, setExposePassword] = useState(false)
  const [type, setType] = useState(props.type)
  return (
    <div className={props.className}>
      {props.label && <FormLabel>{props.label}</FormLabel>}
      <div className="flex row items-center no-wrap w-full">
        <div className="left-0 top-2 p-2 text-gray-400 transition duration-300">
          <TfPassword />
        </div>
        <Field
          type={type}
          name={props.name}
          className={classNames(
            props.classNameForInput,
            `text-sm pl-2 h-12 my-2 w-full softlock-new outline-none
            border-borderColor border-b-2 focus:border-primaryAccentColor`
          )}
          value={value || ''}
          placeholder={props.placeholder}
          {...(props.disabled ? { disabled: true } : {})}
          autoComplete={props.autocompleteOff ? 'off' : ''}
        />
        <div
          onClick={() => {
            setType(!exposePassword ? 'text' : props.type)
            setExposePassword(!exposePassword)
          }}
          className="w-6 "
        >
          {exposePassword ? <Visibility /> : <VisibilityOff />}
        </div>
        <p></p>
      </div>
      <ErrorMessage className="text-alertColor" name={props.name} component="div" />
    </div>
  )
}
